import * as Default from '../default';
// import * as Env from './env/-APP_ENV_TARGET/config.js';

/* Last Release / Update */
export const RELEASE_DATE = `09/21/26`;
export const RELEASE_VERSION = '0.8.13.74'; //Last 0.8.11.13
export const YOUDJ_CORE_VERSION = 'v29.92';

/* App */
export const APP_NAME = `beatport`;
export const API_NAME = `beatport`;

/* Auth */
export const ACRONYME = `bp`; // Link to Beatport
export const API_URL = `https://api.beatport.com`; //`https://api.beatport.com/v4`;
export const API_CLIENT_ID = Default.API_CLIENT_ID;
export const API_SEARCH_URL = Default.API_SEARCH_URL;
export const API_IDENTITY_URL = Default.API_IDENTITY_URL;
export const API_DJAPP_URL = 'https://dj.beatport.com/api';
export const AUTH_DJAPP_URL = `https://dj.beatport.com/api/custom/bp/v2`; // new Identity System - `https://dj.beatport.com/api/custom/tnb` -- V1
/* cppQs6gmpqZDXrmUmwPjPK9UKzjRA4bYV8TXH3UP => not supported the new Identity System */
export const PKCE = true;

export const PARTNERS = ` Pioneer DJ, Traktor Pro, Serato DJ, Denon DJ, Hercules, Djay and more.`;
export const REDIRECT_FORGOT_PASSWORD = `https://www.beatport.com/account/forgot-password?utm_medium=referral&utm_source=nextbeat.you.dj&utm_campaign=link_nextbeat`;

/* Colors */
export const TYPE_LIGHT = Default.TYPE_LIGHT;
export const TYPE_SECONDARY = Default.TYPE_SECONDARY;
export const TYPE_PLACEHOLDER = Default.TYPE_PLACEHOLDER;
export const TYPE_DARK_SECONDARY = Default.TYPE_DARK_SECONDARY;
export const TYPE_DISABLE = Default.TYPE_DISABLE;
export const BRAND_PRIMARY = Default.BRAND_PRIMARY;
export const BRAND_SECONDARY = Default.BRAND_SECONDARY;
export const BRAND_TERTIARY = `#0083C3`;
export const GREY_1 = Default.GREY_1;
export const GREY_2 = Default.GREY_2;
export const BLACK_2 = Default.BLACK_2;
export const BLACK_3 = Default.BLACK_3;
export const BLACK_5 = Default.BLACK_5;
export const SYSTEM_BLACK_2 = Default.SYSTEM_BLACK_2;
export const AUTOMIX_PRIMARY = Default.AUTOMIX_PRIMARY;

/* Covers */
export const OLD_IMG = Default.OLD_IMG;
export const DEFAULT_IMG = Default.DEFAULT_IMG;
export const DEFAULT_AVATAR = Default.DEFAULT_AVATAR;
export const DEFAULT_LABEL = Default.DEFAULT_LABEL;

/* Library */
export const MAX_WIDTH = Default.MAX_WIDTH;
export const MAX_HEIGHT_PLAYER = Default.MAX_HEIGHT_PLAYER;

export const TAB_BAR_HEIGHT = Default.TAB_BAR_HEIGHT;
export const TAB_BAR_GUTTER = Default.TAB_BAR_GUTTER;

export const RECENT_TRACKS_LIMIT = 75;

export const LEFT_MENU_CUSTOM_HEIGHT = 140;

export const LEFT_PAD_TOP = Default.LEFT_PAD_TOP;
export const CONTENT_PAD = Default.CONTENT_PAD;
export const SIDE_WIDTH = Default.SIDE_WIDTH;
export const SIDE_WIDTH_CLOSE = Default.SIDE_WIDTH_CLOSE;
export const CARD_WIDTH = Default.CARD_WIDTH;
export const CARD_HEIGHT = Default.CARD_HEIGHT;
export const CARD_PAD = Default.CARD_PAD;
export const GRID_PAD = Default.GRID_PAD;
export const SUB_SIDEBAR = Default.SUB_SIDEBAR;
export const GRID_WIDTH = Default.GRID_WIDTH;

export const CHART_PAD = Default.CHART_PAD;
export const CHART_IMAGE_SIZE = Default.CHART_IMAGE_SIZE;
export const FILTERS_PAD = Default.FILTERS_PAD;

export const LIST_ROW_HEIGHT = Default.LIST_ROW_HEIGHT;
export const GUTTER_PREVIEW = Default.GUTTER_PREVIEW;
export const LIST_ROW_GAP = Default.LIST_ROW_GAP;

export const GRID_ROW_HEIGHT = Default.GRID_ROW_HEIGHT;

export const GRID_TREND_ROWS = Default.GRID_TREND_ROWS;
export const GRID_TREND_COLUMNS = Default.GRID_TREND_COLUMNS;
export const GRID_TREND_HEIGHT = Default.GRID_TREND_HEIGHT;

export const GRID_TREND_GENRE_ROWS = Default.GRID_TREND_GENRE_ROWS;
export const GRID_TREND_GENRE_COLUMNS = Default.GRID_TREND_GENRE_COLUMNS;
export const GRID_TREND_GENRE_HEIGHT = Default.GRID_TREND_GENRE_HEIGHT;

export const ARTIST_GRID_WIDTH = Default.ARTIST_GRID_WIDTH;
export const ARTIST_COLUMNS_MAX = Default.ARTIST_COLUMNS_MAX;

export const PLAYLIST_COVER_SIZE = Default.PLAYLIST_COVER_SIZE;
export const MENU_COVER_SIZE = Default.MENU_COVER_SIZE;
export const TREND_COVER_SIZE = Default.TREND_COVER_SIZE;
export const ARTIST_LABEL_COVER_RELEASE = Default.ARTIST_LABEL_COVER_RELEASE;

export const GRID_COVER_PAD = Default.GRID_COVER_PAD;
export const GRID_COVER_SIZE = Default.GRID_COVER_SIZE;

export const LC_LEFT_PAD = Default.LC_LEFT_PAD;
export const LC_PAD_BETWEEN = Default.LC_PAD_BETWEEN;

export const STICKY_HEADER_HEIGHT = Default.STICKY_HEADER_HEIGHT;

/* MODULES */
export const MOD_TOOLTIPS = true;
export const MOD_LINKAGE = false;
export const MOD_PRO = false;
export const MOD_FEEDBACK = false;
export const MOD_RECOMMENDATION = true;
/* Party Mode */
export const PARTYMODE = false;
export const PM_URL = null;
export const PM_PATH = '/';
export const PM_MAX_ACTIVES = 0;
/* Iframe - Post Message */
export const IFRAME = true;
/* Freemium */
export const FREEMIUM = true;
/* Welcome Onboarding */
export const ONBOARDING = false;
/* NOTES / NEWS */
export const MOD_NOTES = false;
/* POPUPS */
export const POPUPS = false;
/* Automix */
export const AUTOMIX_ALL = false;

export const HISTORY_V2 = Default.HISTORY_V2;

export const REDIRECT_TRIAL = 'https://www.beatport.com/subscriptions?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen';

/* FOOTER */
export const F_ABOUT_US = `https://about.beatport.com/`;
export const F_COPYRIGHT = `https://research.beatport.com/jfe/form/SV_9FYk8tRdkWAmAJg`;
export const F_CONTACT = `https://support.beatport.com/hc/en-us/articles/4412288252308-Contact-Information`;
export const F_CAREERS = 'https://about.beatport.com/careers/';
export const F_IMAGES = 'https://support.beatport.com/hc/en-us/articles/4412316336404-Beatport-Logos-and-Images';
export const F_SUPPORT = `https://support.beatport.com/hc/en-us`;
export const F_POLICY = `https://support.beatport.com/hc/en-us/articles/4412316093588--Privacy-and-Cookie-Policy`;
export const F_FEEDBACK = null; // `https://research.beatport.com/jfe/form/SV_aeLm5A10L664TX0?authentication=yes&dj_app=Beatport`;
export const F_FEEDBACK_GUEST = null; // `https://research.beatport.com/jfe/form/SV_aeLm5A10L664TX0?authentication=no&dj_app=Beatport`;
export const F_LEGAL = Default.F_LEGAL;
export const F_REDIRECT_NAME = `Beatport DJ`;
export const F_REDIRECT_URL = `https://dj.beatport.com/`;
export const F_TERMS = `https://support.beatport.com/hc/en-us/articles/4414997837716-Terms-and-Conditions`;
export const F_FAQ = 'https://support.beatport.com/hc/en-us/sections/26156582762004-Beatport-DJ-App';
export const F_FAQ_HARDWARE = 'https://support.beatport.com/hc/en-us/articles/26216338970516-Which-DJ-hardware-MIDI-devices-are-supported-by-the-DJ-App';
export const F_RELEASE_NOTES = `https://support.beatport.com/hc/en-us/articles/27159964898324-Beatport-DJ-App-Release-Notes`;


/* SOCIALS */
export const S_FACEBOOK = `https://www.facebook.com/beatport`;
export const S_TWITTER = `https://twitter.com/beatport`;
export const S_INSTAGRAM = `https://www.instagram.com/beatport`;
export const S_YOUTUBE = `https://www.youtube.com/channel/UCyEMqKQPGdj8wKVKt2-agbQ`;
export const S_TWITCH = `https://www.twitch.com/beatportofficial`;
export const S_TIKTOK = `https://www.tiktok.com/@beatport`;
export const S_DISCORD = `https://discord.gg/ezBmCaCknd`;

/* FUNC / OPTIONS */
export const LIMIT_STRING_CAPITALIZE = true;
export const TRENDS_ARTIST_LABEL_MORE = true;
export const GENRES_HAS_FAV = true;
export const GENRES_HAS_CUSTOM_EMPTY = true;
export const ACCESS_STORE = true;
export const HAS_FILTER_EXCLUDE = true;

/* LIST */
export const SHOW_MIX_NAME = true;
export const LIST_HEADER_HAS_REMIXER = true;
export const LIST_HAS_MORE = false;
export const LIST_NAME_WIDTH = `100%`;

/* GENRES */
export const GENRES_HAS_TRENDING_LABELS = true;
export const GENRES_PLAYLISTS_HAS_FILTERS = true;
export const GENRES_CUSTOM_EXTRA_SEARCH_SLUG = [
  { id: 93, words: ['hd'] }, // organic-house-downtempo
  { id: 92, words: ['rdh'] }, // techno-raw-deep-hypnotic
  { id: 99, words: ['rdh'] }, // trance-raw-deep-hypnotic
  { id: 90, words: ['ht'] }, // melodic-house-techno
  { id: 6, words: ['pd'] }, // techno-peak-time-driving
]
export const GENRES_HAS_HYPE = Default.GENRES_HAS_HYPE;
export const GENRES_HAS_EXCLUSIVE = Default.GENRES_HAS_EXCLUSIVE;

/* SPLAHSCREEN */
export const HAS_SPLASH = false;

/* CART */
export const CART_ENABLE = true;
export const CART_ITEM_TYPE = 1;
export const CART_AUDIO_FORMAT = 1;
export const CART_PURCHASE_TYPE = 1;
export const CART_SOURCE_TYPE = 28;